import { render, staticRenderFns } from "./qPopupPaginate.vue?vue&type=template&id=d261ac00&scoped=true&"
import script from "./qPopupPaginate.vue?vue&type=script&lang=ts&"
export * from "./qPopupPaginate.vue?vue&type=script&lang=ts&"
import style0 from "./qPopupPaginate.vue?vue&type=style&index=0&id=d261ac00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d261ac00",
  null
  
)

export default component.exports